<template>
  <kst-container class="kst-company">
    <kst-form :loading="isLoading" :title="title">
      <template #top-right>
        <Action :data="data.data"/>
      </template>
      <Details :data="data.data"/>
    </kst-form>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";

import Action from "./InvoiceSetting_Action";
import Details from "./InvoiceSetting_Details";

import Model from "../InvoiceSettingModel.js";
import Services from "../InvoiceSettingServices.js";

export default {
  mixins: [AxiosMixin, RouterMixin],
  components: {
    Action,
    Details
  },
  data: () => ({
    data: {},
    isLoading: false,
     // error
    formWarnings: null,
    failureInit: null
  }),
  computed: {
    title() {
      return Model.InvoiceSetting.Title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initLoad();
    },

    initLoad() {
      this.isLoading = true;
      this.failureInit = null;

      this.loadDetails();
    },
    initLoad_End() {
      this.isLoading = false;
    },

    loadDetails() {
      const config = Services.getInvoiceSettingNumberFormat();
      this.runAxios(config, null, this.loadDetails_Success, this.loadDetails_Error);
    },
    loadDetails_Success(data) {
      this.data = data;
      this.initLoad_End();
    },
    loadDetails_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    }
  }
}
</script>